import { RouteUrl } from "@/configs/router/routes";
import { useNavigate, useRouterState } from "@tanstack/react-router";

const navItems = [
    { to: RouteUrl.SettingsMultiplier, label: "Multiplier" },
    { to: RouteUrl.SettingsNotifications, label: "Notifications" },
];

const SettingsNavigation = () => {
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });
    const navigate = useNavigate();

    return (
        <div className={`flex gap-3 mb-1`}>
            <nav id="onboarding-settings-nav" className={`rounded-md p-1 bg-surface-container-low w-full`} style={{}}>
                <div className="flex items-center space-x-2">
                    {navItems.map((item) => {
                        const isActive = pathname === item.to;
                        return (
                            <button
                                key={item.to}
                                type="button"
                                className={`nav-tab ${isActive ? "nav-tab-active" : "nav-tab-inactive"}`}
                                onClick={() => {
                                    if (!isActive) {
                                        navigate({ to: item.to });
                                    }
                                }}
                            >
                                {item.label}
                            </button>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
};

export default SettingsNavigation;
